import Request from "../lib/request";
import {browserName, fullBrowserVersion, osName, osVersion} from "react-device-detect";
import uniqueDeviceId from "../lib/generateUniqueDeviceId";
import {IMAGES_API, TICKET_MESSAGES_API, TICKETS_API} from "../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;
const platform = process.env.REACT_APP_CLIENT_ID;
const device_info = {
  serial: uniqueDeviceId(),
  platform: platform,
  os_version: `${osName}_${osVersion}`,
  model: `${browserName}_${fullBrowserVersion}`
};


export const getList = () => {
  return Request({
    method: "get",
    url: `${baseUrl}/${TICKETS_API}`,
    needToken: true
  });
};

export const get = id => {
  return Request({
    method: "get",
    url: `${baseUrl}/${TICKETS_API}/${id}`,
    needToken: true
  });
};


// export const read = id => {
//   return Request({
//     method: "get",
//     url: `${baseUrl}/feedback/${id}/read`,
//     needToken: true
//   });
// };

export const store = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${TICKETS_API}`,
    needToken: true,
    data: {
      ...data,
      device_info: device_info
    }
  });
};


export const storeImage = (image, ticketId, id) => {
  let formData = new FormData();
  formData.append("image", image);
  return Request({
    method: "post",
    url: `${baseUrl}/${TICKETS_API}/${ticketId}/${TICKET_MESSAGES_API}/${id}/${IMAGES_API}`,
    needToken: true,
    headers: {
      "Content-Type": "multipart/forms-data"
    },
    data: formData
  });
};

export const update = (id, data) => {
  return Request({
    method: "put",
    url: `${baseUrl}/${TICKETS_API}/${id}`,
    needToken: true,
    data: {
      ...data,
      device_info: device_info
    }
  });
};